if (!customElements.get("youtube-video")) {
    class CustomYTVideo extends HTMLElement {
        constructor() {
            super();
            this.options = {
                id: "",
                autoplay: false,
                video_element_id: "ytplayer"
            };
            if (this?.dataset?.options) {
                const dataOptions = JSON.parse(this.dataset.options);
                this.options = {
                    ...this.options,
                    ...dataOptions
                }
            }
            if (this.options.id === "") {
                debug() && console.error("youtube ID is missing");
                return
            }
            this.options.autoplay ? this.options.autoplay = 1 : this.options.autoplay = 0;
            this.options.autoplay ? this.options.muted = 1 : this.options.muted = 0;
            this.player;
            this.links = this.querySelectorAll("button");
            this.videoTriggers = this.querySelectorAll("[data-video-trigger]");
            this.videoWrapper = this.closest("[data-video-wrapper]");
            this.overlayImage = this.videoWrapper.querySelector("[data-video-overlay-image]");
            this.overlayMobImage = this.videoWrapper.querySelector("[data-video-overlay-image-mobile]");
            this.overlayText = this.videoWrapper.querySelector("[data-video-text-overlay]");
            window.playerIsReady = false;
            this.loadVideo();
            this.links?.forEach((link => link.addEventListener("click", (function(event) {
                // event.stopImmediatePropagation()
               event.preventDefault();
                  event.stopPropagation();
                 this.loadAndPlayVideo();
            }))));
            this.debouncedOnLoad = debounce((event => {
               this.loadVideo();
                // this.videoObserver(event.type)
            }));
            if (this.options.autoplay === 1) {
                // window.addEventListener("scroll", this.debouncedOnLoad.bind(this));
                window.addEventListener("load", this.debouncedOnLoad.bind(this))
            }
        }
       
        loadVideo() {
            const self = this;
            
            if (self.player) {
                self.player.destroy();
            }
           
            if (window.YT && window.YT.Player) {
                createPlayer();
            } else {
                window.onYouTubeIframeAPIReady = createPlayer;
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        
            function createPlayer() {
                self.player = new YT.Player('player', {
                    height: '675',
                    width: '1200',
                    videoId: self.options.id,
                    playerVars: {
                        playsinline: 0,
                        rel: 0,
                        autoplay: self.options.autoplay,
                        mute: self.options.muted,
                        show_button: self.options.show_button
                    },
                    events: {
                        onReady: onPlayerReady,
                        onStateChange: onPlayerStateChange
                    }
                });
        
                function onPlayerStateChange(event) {
                    if (event.data == 1) {
                        self.videoWrapper.dataset.videoIsPaused = "false";
                    }
                    if (event.data == 2) {
                        self.videoWrapper.dataset.videoIsPaused = "true";
                        self.showPlayerElements();
                    }
                }
        
                function onPlayerReady(event) {
                    window.playerIsReady = true;
                    
                      self.videoTriggers?.forEach((trigger => trigger.addEventListener("click", (function(event) {
                          event.preventDefault();
                          event.stopPropagation();
                          self.playVideo(self.player);
                      }))));
                      if (self.options.autoplay) {
                          self.videoObserver();
                      }
                       
                }
            }
        }
        loadAndPlayVideo() {
        if (this.player && window.playerIsReady) {
            this.playVideo(this.player);
        } else {
            this.loadVideo();
            const interval = setInterval(() => {
                if (this.player && window.playerIsReady) {
                    this.playVideo(this.player);
                    clearInterval(interval);
                }
            }, 100);
          }
        }
        playVideo(player) {
            player.playVideo();
            this.hidePlayerElements()
        }
        pauseVideo(player) {
            player.pauseVideo();
            this.showPlayerElements()
        }
        hidePlayerElements() {
            if (window.innerWidth <= parseInt(this.overlayMobImage?.dataset.bp)) {
                this.overlayMobImage?.classList.add("hidden")
            }
            this.videoTriggers[0]?.classList.add("hidden");
            this.overlayImage?.classList.add("hidden");
            this.overlayText?.classList.add("hidden")
        }
        showPlayerElements() {
            if (window.innerWidth <= parseInt(this.overlayMobImage?.dataset.bp)) {
                this.overlayMobImage?.classList.remove("hidden")
            }
            this.videoTriggers[0]?.classList.remove("hidden");
            this.overlayImage?.classList.remove("hidden");
            this.overlayText?.classList.remove("hidden")
        }
    }
    window.CustomYTVideo = CustomYTVideo;
    customElements.define("youtube-video", CustomYTVideo)
}
//# sourceMappingURL=custom-video-youtube.js.map